/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from "../../config";

export const getSupportedLocale = (language: string): string => {
  const supportedLocale = SUPPORTED_LOCALES.find(
    (locale) => locale.language === language
  );
  return supportedLocale === undefined
    ? DEFAULT_LOCALE
    : supportedLocale.locale;
};
